// http://help.adobe.com/en_US/FlashPlatform/reference/actionscript/3/flash/text/StyleSheet.html
import {TextFormat} from "./TextFormat";
import {getLogger} from "@goodgamestudios/logger";
import {TEXT_FIELDS_LOGGER} from "../../../../../index";
const logger = getLogger(TEXT_FIELDS_LOGGER+".StyleSheet");
export class StyleSheet {
    private _styleNames: any[] = [];
    private _styles: Map<any, any>;

    get styleNames(): any[] {
        return this._styleNames;
    }

    public clear(): void {
        this._styleNames = [];
    }

    public getStyle(styleName: string): any {
        for (let key of Array.from(this._styleNames.keys())) {
            if (key.toString() == styleName) {
                return (this._styles as any)[key];
            }
        }

        return null;
    }

    public parseCSS(CSSText: string): void {
        //TODO: @HTML5 for now it's just mock-up function, if html text should be formatted in the textfield, this function has to be implemented  Please note that Text does not support HTML text, and can only display one font style at a time"
        logger.debug("parseCSS  it's just mock-up function, if html text should be formatted in the textfield, this function has to be implemented");
    }

    public setStyle(styleName: String, styleObject: any): void {
        this._styleNames.push(styleName);
        this._styles.set(styleName, styleObject);
    }

    public transform(t: any): TextFormat {
        //TODO: @HTML5 for now it's just mock-up function, if html text should be formatted in the textfield, this function has to be implemented
        logger.debug("for now it's just mock-up function, if html text should be formatted in the textfield, this function has to be implemented");
        return new TextFormat();
    }
}